<template>
    <div>
      <h2>Testing Moolah</h2>
      <ErrorDisplay/>
      <div id="card-element">
        <!-- Credit card form iFrame will be inserted here -->
      </div>
      <button @click="test">Pay</button>
    </div>
</template>


<script>  
  
</script>

<script>
/* eslint-disable */

/*
https://docs.moolahpay.cc/moolah-payments-api
*/

import axios from 'axios';
import { mapState, mapActions, mapMutations } from 'vuex';
import ErrorDisplay from "@/components/ErrorDisplay/ErrorDisplay";
import mixin from '../../mixin.js';

export default {
  name: 'Test',
  components: { ErrorDisplay }, 
  mixins: [mixin],

  mounted() {    
    let script = document.createElement('script');
    script.type = 'application/javascript';
    script.src = 'https://cdn.poynt.net/collect.js';
    document.head.appendChild(script);  
    
    var _this = this;
    
    script.onload = () => {
      _this.collect = new TokenizeJs("e12ce7ca-7f7b-469d-8e9c-6c36c2270bcd", "urn:aid:df5ae5f0-6360-4024-819f-b7a17b92d5c7");      
      //alert(JSON.stringify(collect));
      const options = {
        iFrame: {
          width: "500px",
          height: "400px",
          border: "1px",
          borderRadius: "4px",
          boxShadow: "0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08)"
        },
        style: {
          theme: "default" // theme: "customer", (alternative default theme)
        },
        displayComponents: {
          firstName: true, // toggle these to true if you wish to show the forms
          lastName: true,
          emailAddress: true,
          submitButton: true,
          showEndingPage: true, // controls ending page,
          labels: true
        },
        /*
        fields: {
          emailAddress: customerEmail,
          firstName: firstName,
          lastName: lastName
        },
        */
        additionalFieldsToValidate: [] // fields to validate
      }
      _this.collect.mount("card-element", document, options);
      _this.collect.on("nonce", async function(response) {
        console.log('Got nonce. Now trying to tokenize and charge', response.data.nonce);
        let payload = {
          siteID: this.siteID,
          nonce: response.data.nonce
        }
        await _this.processMoolahPayment(payload);
      });

      _this.collect.on("error", err  => {
        console.log("collect on error", err);
      });
      
    }
  },

  async created() {
    console.log('created');
  },

  data() {
    return {
      collect: null
    }
  },

  methods:{
    ...mapActions('moolah', ['processMoolahPayment']),

    test() {
      console.log('now getting nonce');
      this.collect.getNonce({});
    }

  },

}
</script>